import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectParseFileStatus = createSelector(
  [(store: RootState) => store.paymentNoticesList.parseFileStatus],
  (parseFileStatus) => parseFileStatus
);
